import React from 'react';
import { Link } from 'react-router-dom'
import './css/FaqBackToIndexButton.css'

export default function FaqBackToIndexButton({ text, to }) {
    return (
        <Link to={to} className="speed back-button"><i className="fas fa-arrow-circle-left"></i> {text}</Link>
    )
}